export const switzerlandProgram = {
  programKey: 'szwajcaria-koleja-przez-alpy',

  /*
   * Każdy termin jest osobnym wyjazdem w Vakanzie.
   */
  tripIds: [3, 4],

  /*
   * Dane, których obecnie nie dostarcza API Vakanzy.
   * Są łączone z terminami według ich ID.
   */
  termDetails: {
    '3': {
      pilotId: 'krzysztof',
      group: 'Dla kobiet i mężczyzn',
      airport: 'Warszawa - Chopina',

      // Dane dostępności są na razie testowe.
      capacity: 18,
      available: 8,

      flightPrice: '+ koszt biletów lotniczych',
      priceNote:
  'Cena przedsprzedażowa obowiązuje do 14 sierpnia.',
  priceNotePrice: 5190,
    },

    '4': {
      pilotId: 'patrycja',
      group: 'Dla kobiet i mężczyzn',
      airport: 'Kraków',

      // Dane dostępności są na razie testowe.
      capacity: 18,
      available: 3,

      flightPrice: '+ koszt biletów lotniczych',
      priceNote:
  'Cena obowiązuje przy rezerwacji do 14 sierpnia.',
  priceNotePrice: 5190,
    },
  },
}